import { createAction } from '@reduxjs/toolkit';

export const menuOpening = createAction('menu/opening', (payload) => ({
  payload,
}));
